module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (74).88ef4e26.jpg";